<template>
    <v-dialog v-model="dialog" width="600">
      <v-card>
        <v-card-title class="headline">
          Dodaj firmę
        </v-card-title>
        <v-card-text>
          <v-form
              ref="newForm"
              v-model="valid"
              lazy-validation
              class="dimension--form mt-5 mb-5"
          >
            <v-row>
              <v-col cols="12" md="12" align-self="start" dense>
                <v-text-field
                    v-model="form.name"
                    :rules="formRules.name"
                    class="pt-0"
                    type="text"
                    label="Nazwa firmy"
                ></v-text-field>
                <v-text-field
                    v-model="form.nip"
                    :rules="formRules.nip"
                    class="pt-0"
                    type="text"
                    label="NIP"
                ></v-text-field>
                <v-text-field
                    v-model="form.email"
                    :rules="formRules.email"
                    class="pt-0"
                    type="text"
                    label="E-mail"
                ></v-text-field>
                <v-text-field
                    v-model="form.city"
                    :rules="formRules.city"
                    class="pt-0"
                    type="text"
                    label="Miasto"
                ></v-text-field>
                <v-text-field
                    v-model="form.postalCode"
                    :rules="formRules.postalCode"
                    class="pt-0"
                    type="text"
                    label="Kod pocztowy"
                ></v-text-field>
                <v-select
                    v-model="form.type"
                    :items="types"
                    :rules="formRules.type"
                    item-text="text"
                    item-value="value"
                    class="pt-0"
                    label="Typ"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <company-categories
                    ref="categories"
                    :id="0"
                    :showSave="false"
                ></company-categories>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  @click.prevent="onSubmit"
                  type="Submit"
                  class="action-btn--green-gradient place-btn wastemaster-action-btn text-none"
                  large
                  :disabled="addingInProgress"
              >Dodaj&nbsp;<v-icon size="24">mdi-send</v-icon></v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>

import api from "@/services/api";
import CompanyCategories from "@/components/CompanyCategories.vue";
import {getItems as getCompanyTypeItems} from "@/enums/CompanyType";

export default {
  name: 'ModalAddCompany',
  components: {CompanyCategories},
  props: {
    item: {},
  },
  mixins: [
  ],
  created() {
  },
  data() {
    return {
      dialog: false,
      addingInProgress: false,
      postalCodeRegex: new RegExp('\\d{2}-\\d{3}'),
      form: {
        name: '',
        nip: '',
        email: '',
      },
      formRules: {
        name: [(value) => !!value || 'Wpisz nazwę firmy'],
        nip: [(value) =>
            (value || '').length === 10 ||
            `Wpisz poprawny numer NIP (10 cyfr)`],
        email: [(value) => !!value || 'Wpisz adres e-mail'],
        type: [(value) => !!value || 'Wybierz typ firmy'],
        city: [
          (value) => !!value || 'Podaj miasto',
          (value) =>
              (value || '').length <= 20 ||
              `Maksymalna długość pola to ${20} znaków`
        ],
        postalCode: [
          (value) =>
              this.postalCodeRegex.test(value || '') ||
              `Wpisz poprawny kod pocztowy w formacie 12-345`
        ],
      },
      valid: false,
      types: getCompanyTypeItems(),
    }
  },
  methods: {
    open() {
      this.dialog = true
    },
    async onSubmit() {
      if (!this.$refs.newForm.validate() || this.addingInProgress) {
        return
      }

      this.addingInProgress = true;

      const company = {
        name: this.form.name,
        nip: this.form.nip,
        email: this.form.email,
        type: this.form.type,
        address: {
          city: this.form.city,
          postalCode: this.form.postalCode
        }
      }
      api
          .post('/api/companies' , company)
          .then((data) => {
            const companyId = data.data.id
            this.$refs.categories.saveCategories(companyId).then(() => {
              this.addingInProgress = false;
              this.$root.$emit('notifySuccess', {
                html: 'Firma została utworzona.',
              });
              this.dialog = false;
              this.form.name = '';
              this.form.nip = '';
              this.form.email = '';
              this.form.city = '';
              this.form.postalCode = '';

              if (this.redirect) {
                this.$router.push({name: 'company-details', params: { id: companyId }})
              }

              if (this.refresh) {
                this.$router.go(0);
              }
            });
          })
          .catch((error) => {
            console.error('Error when adding a company:', error);

            this.addingInProgress = false;
            if (error.response.status === 400) {
              error.response.data.errors.forEach((error) => {
                this.$root.$emit('notifyError', {
                  html: error.message,
                });
              });

            } else {
              this.$root.$emit('notifyError', {
                html: 'Wystąpił błąd.',
              });
            }
          })
    },
  },
}
</script>

<style scoped></style>
